interface Props {
  children?: React.ReactNode;
}
const Divider: React.FC<Props> = ({ children }) => (
  <div className="col-span-3 font-mono font-bold tracking-wider text-gray-500 uppercase divider">{children}</div>
);

export default Divider;
